module.exports = __webpack_public_path__ + "img/undraw_surveillance_kqll.c50c33f4.svg";